const isJson = (s: string) => {
    try {
        JSON.parse(s)
    } catch (e) {
        return true
    }
    return false
}

export default isJson
